<template>
    <div>
        <van-checkbox-group>
        <van-cell-group>
            <van-cell
            v-for="(item, index) in list"
            clickable
            :key="index"
            :title="item.item"
            @click="toggle(index)"
            >
            <van-checkbox
                :name="item"
                ref="checkboxes"
                slot="right-icon"
            />
            </van-cell>
        </van-cell-group>
        </van-checkbox-group>
    </div>
</template>

<script>
import Vue from 'vue';
import { Checkbox, CheckboxGroup } from 'vant';
import { Cell, CellGroup } from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
export default {
    data(){
        return{
            list:[
                {item:'教材资料'},
                {item:'数学'},
                {item:'语文'}
            ],
        }
    },
    methods: {
        toggle(item) {
            this.$refs.checkboxes[item].toggle();
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/folder.vue